import { useEffect } from 'react';
/**
 * Marks figures an answer's check couldn't trace to a source ("$52.0M"), in
 * the rendered answer, with the CSS Custom Highlight API: no change to the
 * markdown or the DOM, so copy, print and screen readers are untouched (the
 * "How I got this" panel says the same in words). Browsers without the API
 * simply show no marks.
 */ export const UNVERIFIED_HIGHLIGHT = 'specra-unverified';
const rangesByMessage = new Map();
function registry() {
    const css = globalThis.CSS;
    return css?.highlights;
}
function publish() {
    const reg = registry();
    const HighlightCtor = globalThis.Highlight;
    if (!reg || !HighlightCtor) return;
    const all = [
        ...rangesByMessage.values()
    ].flat();
    if (all.length === 0) reg.delete(UNVERIFIED_HIGHLIGHT);
    else reg.set(UNVERIFIED_HIGHLIGHT, new HighlightCtor(...all));
}
/** A match that is not the tail or head of a longer number or word ("4.2%" in "34.2%"). */ function standalone(text, at, len) {
    const before = text[at - 1] ?? '';
    const after = text.slice(at + len, at + len + 2);
    return !/[\w.,]/.test(before) && !/^\w/.test(after) && !/^[.,]\d/.test(after);
}
/** Text ranges inside root where any of the figures occurs. */ export function findFigureRanges(root, figures) {
    const wanted = figures.filter((f)=>f.trim().length > 0);
    if (wanted.length === 0 || typeof document === 'undefined') return [];
    const ranges = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for(let node = walker.nextNode(); node; node = walker.nextNode()){
        const text = node.textContent ?? '';
        for (const f of wanted){
            let at = text.indexOf(f);
            while(at >= 0){
                if (standalone(text, at, f.length)) {
                    const r = document.createRange();
                    r.setStart(node, at);
                    r.setEnd(node, at + f.length);
                    ranges.push(r);
                }
                at = text.indexOf(f, at + f.length);
            }
        }
    }
    return ranges;
}
export function useFigureHighlights(root, messageId, figures, /** Changes when the answer's text does, so the marks follow re-renders. */ version) {
    const key = figures.join('\u0000');
    useEffect(()=>{
        const el = root.current;
        if (!el || !key) return;
        rangesByMessage.set(messageId, findFigureRanges(el, key.split('\u0000')));
        publish();
        return ()=>{
            rangesByMessage.delete(messageId);
            publish();
        };
    }, [
        root,
        messageId,
        key,
        version
    ]);
}
